// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mx-c";
export var backButton = "_mx-4";
export var backIcon = "_mx-5";
export var chevronShortcut = "_mx-6";
export var container = "_mx-1";
export var editor = "_mx-8";
export var editorWrapper = "_mx-7";
export var prefix = "_mx-2";
export var searchIcon = "_mx-3";
export var suffix = "_mx-9";
export var suffixContent = "_mx-a";
export var suffixText = "_mx-b";
export var wrapper = "_mx-0";